export var getEncodedUrl = function getEncodedUrl(path, data) {
  var params = Object.keys(data).map(function (key) {
    return key && data[key] ? "".concat(key, "=").concat(encodeURIComponent(data[key])) : "";
  }).filter(Boolean).join("&");
  return "".concat(path, "?").concat(params);
};